import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 4.5C2 3.673 2.673 3 3.5 3h9c.827 0 1.5.673 1.5 1.5V12c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5zm7.59 2.496a.56.56 0 0 0-.93 0l-2.038 2.99L6 9.212a.561.561 0 0 0-.877 0l-1.5 1.875a.561.561 0 0 0 .438.914h7.876c.208 0 .4-.115.496-.3a.56.56 0 0 0-.032-.579zM4.624 6.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
    }, null, -1)
  ]))]))
}
export default { render: render }